/*
 * /aligner-tracker — сколько вы сегодня носили элайнеры.
 *
 * Разведка приложений (TrayMinder, OutTime, Tray With Me, Aligner Snap)
 * дала две вещи, которые стоит взять, и одну, которой нет ни у кого.
 *
 * ВЗЯТО: модель «БЮДЖЕТ ВРЕМЕНИ ВНЕ» вместо накопления часов ношения.
 * Разница не косметическая. «Наносил 19 ч из 22» — это отчёт о прошлом, по
 * которому ничего уже не сделать. «Осталось 40 минут снятого» — это решение
 * прямо сейчас: успею ли я ещё выпить кофе. Второе меняет поведение, первое
 * только сообщает о результате.
 *
 * ⚠️ ЧЕГО НЕТ НИ У КОГО и что ломает все эти приложения на практике:
 * ЧЕЛОВЕК ЗАБЫВАЕТ НАЖАТЬ. Снял за обедом, надел, а нажал только вечером —
 * и в статистике четыре часа «снято» вместо сорока минут. Дальше человек
 * либо бросает трекер, либо ведёт его неправдой. Поэтому здесь любой
 * интервал правится задним числом, а слишком длинный «снято» тул замечает
 * САМ и спрашивает, точно ли так было.
 */

import { downloadIcs } from '../ics-simple.js';

const CFG = window.__ALIGNER || {};
const T = CFG.i18n || {};
const $ = s => document.querySelector(s);
const $$ = s => Array.from(document.querySelectorAll(s));

const KEY = 'aligner-tracker:v1';
const H = 3600000;

const state = {
    goal: CFG.defaultGoal || 22,
    trayDays: CFG.defaultTrayDays || 10,
    tray: 1,
    trayTotal: 0,
    trayStarted: null,
    out: null,              // момент снятия, если сейчас сняты
    intervals: [],          // [{ from, to }] — периоды БЕЗ элайнеров
};

let tick = null;

// ── запуск ──────────────────────────────────────────────────────────────

function boot() {
    restore();

    $('#alToggle').addEventListener('click', toggle);
    $('#alGoal').addEventListener('change', () => {
        state.goal = clamp(+$('#alGoal').value || 22, CFG.goalRange[0], CFG.goalRange[1]);
        $('#alGoal').value = state.goal;
        save(); render();
    });
    $('#alTrayDays').addEventListener('change', () => {
        state.trayDays = clamp(+$('#alTrayDays').value || 10, CFG.trayRange[0], CFG.trayRange[1]);
        $('#alTrayDays').value = state.trayDays;
        save(); render();
    });
    $('#alTrayTotal').addEventListener('change', () => {
        state.trayTotal = Math.max(0, +$('#alTrayTotal').value || 0);
        save(); render();
    });
    $('#alNext').addEventListener('click', () => {
        nextTray();
        if (window.__aeFunnel) window.__aeFunnel('tray_changed', { tray: state.tray });
    });
    $('#alPrev').addEventListener('click', prevTray);
    $('#alIcs').addEventListener('click', exportIcs);
    $('#alCopy').addEventListener('click', copyReport);
    $('#alReset').addEventListener('click', reset);

    render();
    tick = setInterval(render, 15000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) render(); });
    if (window.__stage) window.__stage('ready');
}

function restore() {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (raw) Object.assign(state, raw);
    } catch (_) {}
    $('#alGoal').value = state.goal;
    $('#alTrayDays').value = state.trayDays;
    $('#alTrayTotal').value = state.trayTotal || '';
    if (!state.trayStarted) state.trayStarted = Date.now();
}

function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (_) {}
}

// ── снял / надел ────────────────────────────────────────────────────────

function toggle() {
    if (state.out) {
        const iv = { from: state.out, to: Date.now() };
        state.intervals.push(iv);
        state.out = null;
        save(); render();

        /*
         * Слишком длинный интервал — почти наверняка забытое нажатие, а не
         * четыре часа без элайнеров. Спрашиваем СРАЗУ: через сутки человек
         * уже не вспомнит, а цифра останется и испортит всю статистику.
         */
        if ((iv.to - iv.from) > 3 * H) askIfReal(state.intervals.length - 1);
        if (window.__aeFunnel) window.__aeFunnel('put_in', { mins: Math.round((iv.to - iv.from) / 60000) });
    } else {
        state.out = Date.now();
        save(); render();
        if (window.__aeFunnel) window.__aeFunnel('took_out');
    }
}

function askIfReal(idx) {
    const box = $('#alDoubt');
    const iv = state.intervals[idx];
    box.hidden = false;
    $('#alDoubtText').textContent = fmt(T.doubt_text, { dur: fmtSpan((iv.to - iv.from) / H) });
    if (window.__aeFunnel) window.__aeFunnel('doubt_shown', { hours: Math.round((iv.to - iv.from) / H) });
    $('#alDoubtKeep').onclick = () => {
        box.hidden = true;
        if (window.__aeFunnel) window.__aeFunnel('doubt_kept');
    };
    $('#alDoubtFix').onclick = () => {
        box.hidden = true;
        editInterval(idx);
    };
}

/** Правка интервала задним числом — то, без чего трекер бросают. */
function editInterval(idx) {
    const iv = state.intervals[idx];
    const dlg = $('#alDialog');
    $('#alDlgFrom').value = toLocalInput(new Date(iv.from));
    $('#alDlgTo').value = toLocalInput(new Date(iv.to));

    $('#alDlgSave').onclick = () => {
        const from = new Date($('#alDlgFrom').value).getTime();
        const to = new Date($('#alDlgTo').value).getTime();
        /*
         * ⚠️ Раньше при пустом или перевёрнутом интервале диалог просто
         * ЗАКРЫВАЛСЯ: человек был уверен, что исправил, а не менялось
         * ничего. Молчаливый отказ хуже видимого — он не даёт даже понять,
         * что надо повторить.
         */
        if (!isFinite(from) || !isFinite(to) || to <= from) {
            window.__toast && window.__toast(T.dlg_bad_range, 'warning');
            if (window.__aeFunnel) window.__aeFunnel('interval_rejected');
            return;
        }
        state.intervals[idx] = { from, to, edited: true };
        save(); render();
        if (window.__aeFunnel) window.__aeFunnel('interval_fixed', { hours: Math.round((to - from) / H) });
        dlg.close();
    };
    $('#alDlgDelete').onclick = () => {
        state.intervals.splice(idx, 1);
        save(); render();
        dlg.close();
    };
    if (typeof dlg.showModal === 'function') dlg.showModal();
}

// ── каппы ───────────────────────────────────────────────────────────────

function nextTray() {
    state.tray += 1;
    state.trayStarted = Date.now();
    save(); render();
    window.__toast && window.__toast(fmt(T.tray_changed, { n: state.tray }), 'success');
    if (window.__aeToolComplete) window.__aeToolComplete({ ok: 1, tray: state.tray });
}

function prevTray() {
    state.tray = Math.max(1, state.tray - 1);
    save(); render();
}

// ── расчёт ──────────────────────────────────────────────────────────────

function dayStart(ts) {
    const d = new Date(ts);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
}

/** Сколько минут за сутки элайнеры были СНЯТЫ. */
function outMinutesOn(dayTs) {
    const from = dayStart(dayTs);
    const to = from + 24 * H;
    let ms = 0;

    const all = state.intervals.slice();
    if (state.out) all.push({ from: state.out, to: Date.now() });

    for (const iv of all) {
        // Интервал может пересекать полночь — режем по границам суток,
        // иначе ночное снятие целиком падает в один день и портит оба.
        const a = Math.max(iv.from, from);
        const b = Math.min(iv.to, to);
        if (b > a) ms += b - a;
    }
    return ms / 60000;
}

function budgetMinutes() {
    return (24 - state.goal) * 60;
}

function trayDayNumber() {
    if (!state.trayStarted) return 1;
    return Math.floor((Date.now() - dayStart(state.trayStarted)) / (24 * H)) + 1;
}

// ── отрисовка ───────────────────────────────────────────────────────────

function render() {
    const wearing = !state.out;
    $('#alToggle').textContent = wearing ? T.btn_take_out : T.btn_put_in;
    $('#alToggle').classList.toggle('ghost', !wearing);
    $('#alState').textContent = wearing ? T.state_in : fmt(T.state_out, { since: fmtSpan((Date.now() - state.out) / H) });
    $('#alState').className = 'al-state' + (wearing ? ' is-in' : ' is-out');

    const used = outMinutesOn(Date.now());
    const budget = budgetMinutes();
    const left = budget - used;

    $('#alLeft').textContent = left > 0 ? fmtMin(left) : fmtMin(-left);
    $('#alLeftLabel').textContent = left > 0 ? T.left_label : T.over_label;
    $('#alLeftBox').classList.toggle('is-over', left <= 0);
    $('#alWorn').textContent = fmtMin(24 * 60 - used);

    const pct = Math.max(0, Math.min(100, (used / budget) * 100));
    $('#alBar').style.width = pct + '%';
    $('#alBar').classList.toggle('is-over', left <= 0);

    // Каппа
    $('#alTrayNum').textContent = String(state.tray);
    $('#alTrayOf').textContent = state.trayTotal ? fmt(T.tray_of, { n: state.trayTotal }) : '';
    const day = trayDayNumber();
    $('#alTrayDay').textContent = fmt(T.tray_day, { d: day, of: state.trayDays });
    const leftDays = state.trayDays - day;
    $('#alTrayNext').textContent = leftDays > 0
        ? fmt(T.tray_next_in, { n: leftDays, date: fmtDate(new Date(dayStart(state.trayStarted) + state.trayDays * 24 * H)) })
        : T.tray_next_now;
    $('#alTrayNext').classList.toggle('is-due', leftDays <= 0);

    if (state.trayTotal && state.tray <= state.trayTotal) {
        const rest = state.trayTotal - state.tray;
        $('#alFinish').hidden = false;
        $('#alFinish').textContent = fmt(T.finish_in, {
            weeks: Math.round(rest * state.trayDays / 7),
            date: fmtDate(new Date(Date.now() + rest * state.trayDays * 24 * H)),
        });
    } else {
        $('#alFinish').hidden = true;
    }

    renderWeek();
    renderToday();
}

/** Неделя: столбики «снято» против бюджета. */
function renderWeek() {
    const box = $('#alWeek');
    box.textContent = '';
    const budget = budgetMinutes();

    for (let i = 6; i >= 0; i--) {
        const ts = Date.now() - i * 24 * H;
        const used = outMinutesOn(ts);
        const col = document.createElement('div');
        col.className = 'al-day' + (used > budget ? ' is-over' : '');
        const bar = document.createElement('i');
        bar.style.height = Math.max(3, Math.min(60, (used / Math.max(budget, 1)) * 46)) + 'px';
        const lab = document.createElement('span');
        lab.textContent = new Date(ts).toLocaleDateString(window.__LOCALE || 'ru', { weekday: 'short' });
        col.append(bar, lab);
        col.title = fmt(T.day_title, { day: fmtDate(new Date(ts)), out: fmtMin(used), worn: fmtMin(24 * 60 - used) });
        box.appendChild(col);
    }
}

/** Сегодняшние снятия — с возможностью поправить каждое. */
function renderToday() {
    const box = $('#alToday');
    box.textContent = '';
    const from = dayStart(Date.now());
    const rows = state.intervals
        .map((iv, i) => ({ iv, i }))
        .filter(x => x.iv.to > from)
        .reverse();

    $('#alTodayEmpty').hidden = rows.length > 0;

    for (const { iv, i } of rows) {
        const row = document.createElement('div');
        row.className = 'al-iv';
        const t = document.createElement('span');
        t.textContent = timeOf(iv.from) + ' – ' + timeOf(iv.to);
        const d = document.createElement('b');
        d.textContent = fmtMin((iv.to - iv.from) / 60000);
        const e = document.createElement('button');
        e.type = 'button';
        e.className = 'tc-btn sm ghost';
        e.textContent = iv.edited ? T.edited : T.fix;
        e.addEventListener('click', () => editInterval(i));
        row.append(t, d, e);
        box.appendChild(row);
    }
}

// ── экспорт ─────────────────────────────────────────────────────────────

function exportIcs() {
    const events = [];
    const rest = state.trayTotal ? state.trayTotal - state.tray : 12;
    for (let k = 1; k <= Math.min(rest, 40); k++) {
        const at = new Date(dayStart(state.trayStarted) + (state.trayDays * k) * 24 * H);
        at.setHours(21, 0, 0, 0);
        events.push({
            start: at,
            summary: fmt(T.ics_summary, { n: state.tray + k }),
            description: T.ics_desc,
            alarmMinutes: 0,
        });
    }
    const n = downloadIcs(events, { name: T.ics_name, prodid: 'aligner-tracker', filename: 'aligner-trays' });
    if (!n) window.__toast && window.__toast(T.ics_none, 'info');
}

async function copyReport() {
    const days = [];
    const budget = budgetMinutes();
    for (let i = 13; i >= 0; i--) {
        const ts = Date.now() - i * 24 * H;
        const used = outMinutesOn(ts);
        days.push({ ts, worn: 24 * 60 - used, ok: used <= budget });
    }
    const good = days.filter(d => d.ok).length;
    const avg = days.reduce((s, d) => s + d.worn, 0) / days.length / 60;

    const text = [
        T.rep_head,
        fmt(T.rep_tray, { n: state.tray, of: state.trayTotal || '—', day: trayDayNumber(), days: state.trayDays }),
        fmt(T.rep_goal, { goal: state.goal }),
        fmt(T.rep_avg, { avg: avg.toFixed(1) }),
        fmt(T.rep_days, { good, total: days.length }),
    ].join('\n');
    try {
        await navigator.clipboard.writeText(text);
        window.__toast && window.__toast(T.copied, 'success');
    } catch (e) { window.__handleError(e, 'aligner:copy'); }
}

function reset() {
    if (!confirm(T.reset_confirm)) return;
    state.intervals = [];
    state.out = null;
    save(); render();
}

// ── мелочи ──────────────────────────────────────────────────────────────

function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

function fmtMin(mins) {
    const m = Math.max(0, Math.round(mins));
    const h = Math.floor(m / 60), r = m % 60;
    return h ? (r ? fmt(T.hm, { h, m: r }) : fmt(T.h, { h })) : fmt(T.m, { m: r });
}

function fmtSpan(hours) { return fmtMin(hours * 60); }

function timeOf(ts) {
    return new Date(ts).toLocaleTimeString(window.__LOCALE || 'ru', { hour: '2-digit', minute: '2-digit' });
}

function fmtDate(d) {
    return d.toLocaleDateString(window.__LOCALE || 'ru', { day: 'numeric', month: 'short' });
}

function toLocalInput(d) {
    const p = n => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

function fmt(tpl, vars) {
    return String(tpl || '').replace(/:(\w+)/g, (m, k) => (k in vars ? String(vars[k]) : m));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
